// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__uzPnu","requiredAsterisk":"Info_requiredAsterisk__13Pl1"};